// extracted by mini-css-extract-plugin
export default {"contactTitle":"contact_contactTitle__jMzGq","description":"contact_description__oOoVV","icons":"contact_icons__CxRii","form":"contact_form__K7Q-B","list":"contact_list__791Lc"};